import "./loader.css";

function LoaderComponent() {
  return (
    <div className="h-[100vh] w-[100vw] bg-gray-900 flex justify-center items-center">
      <div className="loader"></div>
    </div>
  );
}

export default LoaderComponent;
